/**
 * Scroll to top utility function
 * Smoothly scrolls to the top of the page
 */
export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth',
  });
};

/**
 * Check if current path matches target path
 * @param {string} currentPath - Current location pathname
 * @param {string} targetPath - Target path to compare
 * @returns {boolean} - True if paths match
 */
export const isCurrentPage = (currentPath, targetPath) => {
  return currentPath === targetPath;
};
